import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

export const twMergeConfig = {
  extend: {
    classGroups: {
      'font-size': [
        { text: ['flea', 'ant', 'frog', 'rat', 'rabbit', 'cat', 'dog', 'leopard', 'wolf', 'deer', 'bear'] },
      ],
    },
  },
};

export const twMerge = extendTailwindMerge(twMergeConfig);

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
